import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=45871512&"
import script from "./tools.vue?vue&type=script&lang=js&"
export * from "./tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports